<template>
    <div>
        <Curves
            background="EEF1F4"
            foreground="fff"
            location="bottomRight"
        />
        <div class="grey-bend">
            <div class="services">
            <h3 v-text="servicesTitle" />
            <ul class="list-none">
                <li v-for="service in services" :key="service.ServiceDefId">
                    <NuxtLink :to="'/services/' + service.ServiceSlug + '/'">{{ service.ServiceName }}</NuxtLink>
                </li>
            </ul>
            </div>
        </div>
        <Curves background="EEF1F4" foreground="fff" location="topRight" />
    </div>
</template>

<script setup>
const props = defineProps({
  services: Array,
  servicesTitle: String,
});
</script>

<style scoped>

</style>